import { parseJsonStringSafe } from './parse-json-safe';

export const readStoredJson = <T>(key: string, fallback: T): T => {
  try {
    return parseJsonStringSafe<T>(localStorage.getItem(key)) ?? fallback;
  } catch {
    return fallback;
  }
};
